import EllipsisGroup from './ellipsisGroup';

export default EllipsisGroup;
